import loadable from '@loadable/component';

import publicListQuery from './query.graphql';

import { LIMIT } from './constants';

const PublicList = loadable(() =>
  import(/* webpackChunkName: "lists" */ './public-list')
);

PublicList.graphQL = publicListQuery;

PublicList.variables = ({ id, offset }) => {
  return {
    id,
    limit: LIMIT,
    offset,
  };
};

PublicList.loadOrder = [{}];

export default PublicList;
